import React, { useEffect, useState } from "react";
import Banner from "./../banner/banner";
import LeftSponsers from "./../leftSponsers/leftSponsers";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import * as api from "./../../api/api";
import * as c from "./../../const";
import { Link } from "react-router-dom";
import Comment from "./comment";
//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { CKEditor } from "ckeditor4-react";
import DatePicker from "react-datepicker";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function Blog(props) {
  const classes = useStyles();
  const [news, setNews] = useState("");
  const [loader, setLoader] = useState(true);
  const [category, setCategory] = useState("");
  const [imgSrc, setImgSrc] = useState("");
  const [imgIndex, setImgIndex] = useState(0);
  const [banner, setBanner] = useState("");
  const [comments, setComments] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const user_comments_get = async () => {
    try {
      const reqObj = {
        news_id: props.match.params.id,
      };
      const response = await api.user_comments_get_byid(reqObj);
      console.log("response", response);
      setComments(response.data);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    user_comments_get();
    const newsApi = async () => {
      window.scrollTo(0, 0);
      try {
        const id = props.match.params.id;
        let response = await api.news(id);
        let res = await api.banner(5);

        if (res) {
          setBanner(res.image);
        }
        setNews(response);
        // console.log(response);
        const img = response.image;
        setImgSrc(img);
        setLoader(false);
      } catch (e) {
        console.log(e);
      }
    };
    const categoryApi = async () => {
      try {
        let response = await api.category();
        setCategory(response.data);
      } catch (e) {
        console.log(e);
      }
    };
    localStorage.setItem("blogId", props.match.params.id);
    newsApi();
    categoryApi();
  }, []);

  const newDate = new Date(news.created_at);
  // let monthName = month[newDate.getMonth()];
  // let date = newDate.getDate();

  const url = c.URL;
  let src = `${url}/${imgSrc[imgIndex]}`;

  return (
    <div>
      <Banner img={banner} />
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsers />
              </div>
            </div>

            <div className="col-lg-9 col-md-12">
              <div id="ourblog" className="ourblog">
                <div className="container">
                  <div className="title text-center mx-auto pb-3">
                    <h2>Our Recent News</h2>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-lg-12 col-md-12">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="blog-post mb-3">
                            <div className="post-media">
                              <div className="row">
                                <div
                                  className="col-md-12"
                                  style={{ height: "500px" }}
                                >
                                  {/* <span className="event-calender blog-date">
                                    {date}
                                    <span>{monthName}</span>
                                  </span> */}
                                  <img
                                    src={src}
                                    alt="blog"
                                    className="img-fluid"
                                    style={{
                                      height: "500px",
                                      width: "100%",
                                      objectFit: "fill",
                                    }}
                                  />
                                </div>
                                {Object.keys(imgSrc).map((index) => {
                                  let subSrc = `${url}/${imgSrc[index]}`;
                                  return (
                                    <div className="d-flex justify-content-start pt-2 pr-2">
                                      <img
                                        src={subSrc}
                                        alt="blog"
                                        className="img-fluid"
                                        width="120px"
                                        height="120px"
                                        onClick={() => setImgIndex(index)}
                                        // style={{ objectFit: "cover" }}
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            <div className="post-meta">
                              <span>by {news ? news.sponsor.name : ""},</span>
                            </div>
                            <div className="post-header">
                              <h2>{news.title}</h2>
                            </div>
                            <div className="post-entry">
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: news.details,
                                }}
                              ></p>
                              <p>
                                <a
                                  href={news.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {news.url}
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="justify-content-end row">
                        <div className="col-lg-3 text-right">
                          <button
                            data-toggle="modal"
                            data-target="#exampleModal"
                            className="btn btn-primary w-100"
                          >
                            Comment <i class="fas fa-comment"></i>
                          </button>
                        </div>
                      </div>
                      <div
                        class="modal fade"
                        id="exampleModal"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-lg" role="document">
                          <div class="modal-content comment">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel">
                                Comment Here
                              </h5>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div className="row">
                                <div className="col-lg-12">
                                  <Comment />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* <div className="col-lg-2 text-center">
                          <span class="border userImg"></span>
                        </div> */}
                        <div className="commentSection-f">
                          {comments.map((item, index) => (
                            <>
                              <div className="col-lg-12">
                                <p
                                  className="commentsHere"
                                  dangerouslySetInnerHTML={{
                                    __html: item.comments,
                                  }}
                                ></p>
                                <h4 className="commentUser">
                                  <span className="userNameComment">
                                    {" "}
                                    {item.name}
                                  </span>
                                  {moment(item.created_at).format("MM/DD/YYYY")}
                                </h4>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-lg-3 col-md-12">
                      <div className="sidebar-widget">
                        <h4>Categories</h4>
                        <ul className="categories">
                          {Object.keys(category).map((item) => {
                            // console.log(category);
                            return (
                              <li>
                                <Link
                                  to={{
                                    pathname: "/results",
                                    state: {
                                      data: {
                                        category_id: category[item].id,
                                      },
                                    },
                                  }}
                                >
                                  {category[item].name}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
